export function renderLabelWithDescriptionLayoutTemplate({
  indent,
  labelJsx,
  descriptionJsx
}: {
  indent: string
  labelJsx: string
  descriptionJsx: string
}): string {
  return `<div className="flex flex-col gap-1">
${indent}  ${labelJsx}
${indent}  ${descriptionJsx}
${indent}</div>`
}
